var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31.999,
  cy: 32,
  r: 29.019,
  stroke: "#333",
  strokeWidth: 2.85
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.85,
  d: "m17.932 31.153 9.378 9.378L46.068 23.47"
})));
export { SvgIconCheckCircle as ReactComponent };